<div class="market-history">
  <h2 class="heading">
    {{"transactions-summary"|translate}}
    <span class="news-type-badge rounded-pill mx-2 totals-bg" *ngIf="trades.length>0" >
      {{trades.length}}
    </span>
    <button class="btn-bg-1" style="background:transparent; border: 0;" (click)="fetchTradesSummary(tradeRequest)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise icon-reload-color"
        viewBox="0 0 16 16" >
        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
      </svg>
    </button>
  </h2>
  <div class="custom-news-container">
    <div class="row no-data m-0" *ngIf="!trades && !isTradesLoading">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{"no-trades-hint"|translate}} </h6>
        </div>
      </div>
    </div>
    <div class="row no-data m-0" *ngIf="trades && trades.length == 0 && !isTradesLoading">
      <div class="col-md-12">
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <h6 class="nodata-msg"> {{'no-trades-hint'|translate}} </h6>
        </div>
      </div>
    </div>
    <tbody class="d-flex justify-content-center" *ngIf="isTradesLoading">
      <div class="spinner-border  text-secondary m-5" role="status">
        <span class="sr-only"></span>
      </div>
    </tbody>
    <div *ngIf="!isTradesLoading  && trades.length>0" style="height: 100% !important;">
      <ul>
        <li *ngFor="let item of trades let t = index">
          <div class="d-flex justify-content-between my-2" data-toggle="collapse" attr.data-target="#collapse-{{t}}">
            <span class="text-muted ellipsis  summary-text-color-theme" >
              {{(translate.currentLang=='en')?item.EngName:item.ArbName}}
            </span>
            <div class="row">
              <span class="news-type-badge rounded-pill mx-2" [ngStyle]="getColor(item.TransactionTypeID)">
                {{(item.TransactionTypeID ==2 || item.TransactionTypeID == 3 || item.TransactionTypeID == 5
                )?("sell"|translate):("buy"|translate)}}
              </span>
            </div>
          </div>
          <div attr.id="collapse-{{t}}" class="collapse hide">
            <span class="text-muted col headerName  summary-text-color-theme"
              style="margin-left: 79%; margin-right: 6px;">
              {{(translate.currentLang=='en')?item.AbbreviationE:item.AbbreviationA}}
            </span>
            <div class="d-flex justify-content-between mt-2">
              <span class="col-12 p-0 align-self-center summary-text-color-theme" style="text-align: start;">
                {{"gross-sales"|translate}}
                <hint-popover [key]="'gross-sales-hint'"></hint-popover>
                <br>
                <span class="text-warning d-inline-flex">
                  {{item.TransactionQty|number}}
                  <span class="mx-1 text-warning">@</span>
                  <span class="text-warning"> {{item.TransactionPrice }} = {{item.OrderValue | number: "1.0"}}</span>
                </span>
              </span>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <span class="col-12 p-0 align-self-center summary-text-color-theme" style="text-align: start;">
                {{"estimated-sales"|translate}}

                <hint-popover [key]="'estimated-sales-hint'"></hint-popover>
                <br>
                <span class="text-warning d-inline-flex" style="color:darkturquoise !important">
                  {{item.TransactionQty|number}}
                  <span class="mx-1 text-warning" style="color:darkturquoise !important">@</span>
                  <span class="text-warning" style="color:darkturquoise !important"> {{item.EstimatedPrice }} =
                    {{item.EstimatedValue | number: "1.0"}}</span>
                </span>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
